import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Divider, Typography } from 'shared/ui'
import { getCDNAssetURL } from 'shared/lib'
import BannerImg from 'shared/assets/images/billing/BannerImg.png'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AutoRechargeCard } from 'entities/Billing/ui/AutoRechargeWidget/ui/AutoRechargeCard'
import { CounterWithInfo } from 'pages/settings/pages/billing/pages/upgrade/ui/CounterWithInfo/CounterWithInfo'
import { DowngradeEffectiveDateAlert } from 'pages/settings/pages/billing/pages/upgrade/ui/DowngradeEffectiveDateAlert/DowngradeEffectiveDateAlert'
import { DowngradeContent } from 'pages/settings/pages/billing/pages/upgrade/ui/DowngradeContent/DowngradeContent'
import { PhoneCheckr, PhoneCheckrStore } from 'pages/settings/ui/PhoneCheckr'
import { useBillingUpgradePageContext } from 'pages/settings/pages/billing/pages/upgrade/context/upgradeContext'
import styles from './styles.module.scss'

export const UpgradeSecondLeftContent = observer(() => {
  const store = useBillingUpgradePageContext()
  const entities = useEntitiesContext()
  const phoneCheckrStore = useMemo(() => new PhoneCheckrStore(entities), [entities])

  if (store.isDowngrade) {
    return (
      <div className={styles.infoContainerWrapper}>
        <DowngradeEffectiveDateAlert
          effectiveDate={store.downgradeEffectiveDate ?? undefined}
          marginBottom={32}
        />
        <DowngradeContent store={store.downgradeContentStore} />
      </div>
    )
  }

  const { showAutoRechargeBlock, showPhoneCheckrBlock, autoRechargeWidgetStore } = store

  return (
    <div className={styles.infoContainerWrapper}>
      <div className={styles.bannerImageWrapper}>
        <Typography
          ariaLabel='billing_upgrade_second_page_banner_title'
          variant='heading-md'
          color='var(--content-primary-primary)'
          className={styles.bannerTitle}
        >
          Supercharge your plan with add-ons
        </Typography>
        <img src={getCDNAssetURL(BannerImg)} alt='banner' className={styles.bannerImage} />
      </div>

      <div className={styles.infoContainer}>
        <Typography
          ariaLabel='billing_upgrade_second_page_additional_credits_title'
          variant='body-md-regular'
          color='var(--content-primary-secondary)'
        >
          Additional
        </Typography>
        <CounterWithInfo
          icon='users'
          name={'Seats'}
          cost={store.additionalSeatPrice}
          counter={store.seats}
          changeCounter={store.changeSeatsCounter}
        />
        <Divider className={styles.divider} />
        <CounterWithInfo
          icon='phone'
          name={'Numbers'}
          cost={store.additionalNumbersPrice}
          counter={store.numbers}
          changeCounter={store.changeNumbersCounter}
        />
      </div>

      <div className={styles.infoContainerWrapper}>
        {showAutoRechargeBlock && (
          <AutoRechargeCard
            store={autoRechargeWidgetStore}
            version='borderWithIcon'
            showFreeLabel
            className={styles.autoRechargeCard}
          />
        )}
        {showPhoneCheckrBlock && <PhoneCheckr store={phoneCheckrStore} />}
      </div>
    </div>
  )
})
